import {NavLink} from 'react-router-dom';

export default function Sidebar() {
  return (
    <aside className="sidebar d-flex flex-column p-3"><br></br>
      {/* if active add active class to navlink  */}
      <ul className="nav nav-pills flex-column gap-2">
        <li className="nav-item">
          <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Dashboard</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/all-jobs" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>All Jobs</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/add-job" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Add New Job</NavLink>
        </li>
      </ul>
    </aside>
  );
}
